import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IRemoveWorkerFromInterventionRequestAction {
  data: {
    id: string;
    intervention_id: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function removeWorkerRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IRemoveWorkerFromInterventionRequestAction>,
) {
  draft.removeWorker.config.isLoading = true;
}

export default removeWorkerRequest;
